var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAttention = function SvgIconAttention(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Attention",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    strokeWidth: 0
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27654",
    "data-name": "Rectangle 27654",
    width: 56,
    height: 56,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_99113",
    "data-name": "Group 99113",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12138",
    "data-name": "Circle",
    d: "M28 0A28 28 0 1 1 0 28 28 28 0 0 1 28 0",
    fill: "#ff3d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12139",
    "data-name": "Exclamation-Mark",
    d: "M28.022 43.652a4 4 0 0 1-2.836-1.042 3.326 3.326 0 0 1-1.118-2.525A3.218 3.218 0 0 1 25.2 37.55a4.137 4.137 0 0 1 2.826-.988 4.015 4.015 0 0 1 2.814 1 3.271 3.271 0 0 1 1.1 2.524 3.342 3.342 0 0 1-1.085 2.557 3.983 3.983 0 0 1-2.825 1.01m3.523-31.3-.838 21.227h-5.5l-.8-21.227Z",
    fill: "#fff",
    "data-no-fill": "true"
  }))));
};
export { SvgIconAttention as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iQXR0ZW50aW9uIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1NiA1NiIgc3Ryb2tlLXdpZHRoPSIwIj4KICAgIDxkZWZzPgogICAgICAgIDxjbGlwUGF0aCBpZD0iY2xpcC1wYXRoIj4KICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZV8yNzY1NCIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgMjc2NTQiIHdpZHRoPSI1NiIgaGVpZ2h0PSI1NiIgZmlsbD0ibm9uZSIvPgogICAgICAgIDwvY2xpcFBhdGg+CiAgICA8L2RlZnM+CiAgICA8ZyBpZD0iR3JvdXBfOTkxMTMiIGRhdGEtbmFtZT0iR3JvdXAgOTkxMTMiIGNsaXAtcGF0aD0idXJsKCNjbGlwLXBhdGgpIj4KICAgICAgICA8cGF0aCBpZD0iUGF0aF8xMjEzOCIgZGF0YS1uYW1lPSJDaXJjbGUiIGQ9Ik0yOCwwQTI4LDI4LDAsMSwxLDAsMjgsMjgsMjgsMCwwLDEsMjgsMCIgZmlsbD0iI2ZmM2Q2NCIvPgogICAgICAgIDxwYXRoIGlkPSJQYXRoXzEyMTM5IiBkYXRhLW5hbWU9IkV4Y2xhbWF0aW9uLU1hcmsiCiAgICAgICAgICAgICAgZD0iTTI4LjAyMiw0My42NTJhNCw0LDAsMCwxLTIuODM2LTEuMDQyLDMuMzI2LDMuMzI2LDAsMCwxLTEuMTE4LTIuNTI1QTMuMjE4LDMuMjE4LDAsMCwxLDI1LjIsMzcuNTVhNC4xMzcsNC4xMzcsMCwwLDEsMi44MjYtLjk4OCw0LjAxNSw0LjAxNSwwLDAsMSwyLjgxNCwxLDMuMjcxLDMuMjcxLDAsMCwxLDEuMSwyLjUyNCwzLjM0MiwzLjM0MiwwLDAsMS0xLjA4NSwyLjU1NywzLjk4MywzLjk4MywwLDAsMS0yLjgyNSwxLjAxbTMuNTIzLTMxLjMtLjgzOCwyMS4yMjdoLTUuNWwtLjgtMjEuMjI3WiIKICAgICAgICAgICAgICBmaWxsPSIjZmZmIiBkYXRhLW5vLWZpbGw9InRydWUiLz4KICAgIDwvZz4KPC9zdmc+Cg==";